/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicPatchManager extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicPatchManager");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicPatchManager.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicPatchManager>): BackgroundJobPayloadForPeriodicPatchManager {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicPatchManager(), model);
        BackgroundJobPayloadForPeriodicPatchManager.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicPatchManager>): BackgroundJobPayloadForPeriodicPatchManager {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicPatchManager.newInstance(<BackgroundJobPayloadForPeriodicPatchManager> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicPatchManager) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicPatchManager.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicPatchManager): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicPatchManager.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.counter === undefined) {
            this.counter = 0;
        }
    }

    cloud_accounts: Array<string>;

    /**
     * Number of times the job has to retry for periodic job
     */
    counter: number;

}
